<template>
  <div class="position-relative d-none" id="subheader">
    <b-container>
      <b-row align-v="center" no-gutters>
        <b-col cols="12" class="position-static d-flex align-items-center justify-content-between">
          <!-- Logo -->
          <a :href="`${baseUrl}`" class="d-block">
            <div class="py-3 h-100">
              <img :src="require('@/assets/img/logo/logo-bbw.svg')" alt="bbw" class="img img-fluid logo-header" />
            </div>
          </a>
          <!-- /Logo -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

const BBW_BASE_URL = 'https://bbw.jobnet.solutions';

@Component
export default class HeaderInformationNavigationBbw extends Vue {
  get baseUrl() {
    return BBW_BASE_URL;
  }

  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return AppModule.language || 'de';
  }
}
</script>

<style scoped lang="scss">
[theme="default"] {
  #subheader {
    background-color: white !important;
  }
  .logo-header {
    width: 178px;
  }
}
</style>
